import { Component, OnInit, HostListener, Input, ViewChild, DebugNode, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { global } from '../../shared/global';
import { HttpErrorResponse } from '@angular/common/http';
import { RegistrationService } from './registrationlist.service';
import { DOCUMENT } from '@angular/common';


declare var $: any;

@Component({
  selector: 'app-registrationlist',
  templateUrl: './registrationlist.component.html',
  styleUrls: ['./registrationlist.component.css']
})
export class RegistrationlistComponent implements OnInit {
  p: number = 1;
  responseData: any;
  registrationlist: Array<any>;
  pageLimit = global.pageLimit;
  searchtext;
  orderByField = "Board";
  reverseSort = false;
  dataTable: any;
  isDesc: boolean;
  column: string;
  searchdata = "";
  totalPages = 10;
  totalRegistration : any;
  constructor(private service: RegistrationService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    //$('#example').dataTable();
    if (localStorage.length == 0) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
        this.getRegistrationList(this.p);
  });
    $("#searchtext").val("");
    this.getRegistrationList(this.p);
  }
  setpage() {
    this.p = 1;
  }
  getRegistrationList(page) {
    this.spinner.show();
    this.p = page;
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      this.searchdata = $("#searchtext").val();
    }
    const data = {
      SearchText : this.searchdata,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit,
      YearID : localStorage.getItem("YearID")
    };
    this.service.getRegistrationList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.registrationlist = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
        } else {
          this.registrationlist = this.responseData.RegistrationList;
         // this.totalPages = this.responseData.totalPages;
          this.totalRegistration = this.responseData.totalCount;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/login']);
      });
  }

  editRegistration(id) {
    this.router.navigate(['/registration/' + id]);
  }
  deleteRegistration(id, status) {
    var msg;
    if (status == 1)
      msg = "Are you sure you want to deactivate college ?"
    else
      msg = "Are you sure you want to activate college ?"
    var a = confirm(msg);
    if (a) {
      this.spinner.show();
      const data = {
        ID: id,
        Status: status
      };
      this.service.deleteRegistration(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
          } else {
            this.toastr.success("Status updated successfully");
            this.getRegistrationList(this.p);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  addNew() {
    this.router.navigate(['/registration']);
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc; //change the direction    
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.registrationlist.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  allocateFees(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/feesincrease/' + HashCode]);
  }
  viewRequest(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/viewallocaterequest/' + HashCode]);
  }
  bookDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/bookdetail/' + HashCode]);
  }
  infrastructureDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/infrastructuredetail/' + HashCode]);
  }
  classroomDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/classroomdetail/' + HashCode]);
  }
  landownerDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/landownerdetail/' + HashCode]);
  }
  employeeadditionaldetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/employeeadditionaldetail/' + HashCode]);
  }
  expenseDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/expensedetail/' + HashCode]);
  }
  rentalDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/rentaldetail/' + HashCode]);
  }
  establishmentDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/establishmentdetail/' + HashCode]);
  }
  ViewScholarship(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/scholarshipdetail/' + HashCode]);
  }
  ViewDocumentUpload(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/schooldocumentupload/' + HashCode]);
  }
  viewProfile(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/schoolprofile/' + HashCode]);
  }
  ViewConstructionDetail(HashCode, SchoolName) {
    localStorage.setItem("SchoolName", SchoolName);
    this.router.navigate(['/constructiondetail/' + HashCode]);
  }
  resendPassword(emailid) {
    this.spinner.show();
    var data = {
      emailID: emailid
    }
    this.service.forgetPasswordSchool(data)
      .subscribe((data1: Response) => {
        this.spinner.hide();
        this.responseData = data1;
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return;
        } else {
          this.toastr.success(this.responseData.message);
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }
  
}
